import {
  Component,
  OnInit,
  Input,
  Output,
  Injector,
  EventEmitter,
} from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { BaseComponent } from '@app/shared/base/base-component/base-component.component';
import { CommonService } from '@product/shared/services/common.service';
import { distinctUntilChanged, Subject, takeUntil } from 'rxjs';
import {
  Entities,
  ScopeValidValues,
  UseInLayeredNavigationValidValues,
  YesNoValidValues,
} from 'src/global-variables';

@Component({
  selector: 'app-attribute-base-info',
  templateUrl: './attribute-base-info.component.html',
  styleUrls: ['./attribute-base-info.component.less'],
})
export class AttributeBaseInfoComponent
  extends BaseComponent
  implements OnInit
{
  @Input() mode: string = '';
  @Input() formGroup: FormGroup;
  @Input() hasUomAttribute: boolean = false;
  @Output() hasUomChanged = new EventEmitter();
  @Input() languageId: number = 0; 
  private originalLabel: string | null = null;
  defaultLanguage: any;
  private _record: any;
  public get record(): any {
    return this._record;
  }
  @Input()
  public set record(value: any) {
    this._record = value;
    if (this._record?.UseAigeneration === true) {
      this.ShowAiQuestionSection = true;
    }
  }
  entitiesValues = Entities;
  scopeValues = ScopeValidValues;
  yesNoValues = YesNoValidValues;
  useLayeredNavOptions = UseInLayeredNavigationValidValues;

  ShowAiQuestionSection = false;
  destroySubject$ = new Subject<void>();
  constructor(injector: Injector) {
    super(injector);
  }
 
  ngOnInit() {    
    this.subscriptions.push(
      this.formGroup.get('UseAigeneration')!.valueChanges.subscribe((value) => {
        if (value === true) {
          this.ShowAiQuestionSection = true;
        } else {
          this.ShowAiQuestionSection = false;
        }
      })
    );
    // console.log('For Group : ',this.formGroup);
    this.setValues();
  }

 override ngOnDestroy(): void {
    this.destroySubject$.next();
    this.destroySubject$.complete();
  }

  private setValues() {
    
    this.formGroup.get('Visible')?.setValue(this.formGroup.get('Visible')?.value);
    this.formGroup.get('IsUnique')?.setValue(this.formGroup.get('IsUnique')?.value);
    this.formGroup.get('IsRequired')?.setValue(this.formGroup.get('IsRequired')?.value);
    this.formGroup.get('AddToCol')?.setValue(this.formGroup.get('AddToCol')?.value);
    this.formGroup.get('UseAigeneration')?.setValue(this.formGroup.get('UseAigeneration')?.value);
    this.formGroup.get('VisibleInCatalogPages')?.setValue(this.formGroup.get('VisibleInCatalogPages')?.value);
    this.formGroup.get('UseInLayeredNavigation')?.setValue(this.formGroup.get('UseInLayeredNavigation')?.value);
    this.formGroup.get('UseInSearch')?.setValue(this.formGroup.get('UseInSearch')?.value);
    this.formGroup.get('UsedInProductListing')?.setValue(this.formGroup.get('UsedInProductListing')?.value );
    this.formGroup.get('UsedForSortingInProductListing')?.setValue(this.formGroup.get('UsedForSortingInProductListing')?.value);
    this.formGroup.get('Position')?.setValue(this.formGroup.get('Position')?.value); 
  }
  
}
